// Back button cart refresh
//
// Previously this reloaded the cart page on EVERY visit, which added a full page
// load to the request budget and helped trip Shopify's rate limiting / Cloudflare
// challenge. A normal forward navigation already renders fresh Liquid, so it needs
// no reload. The only case where the rendered cart can be stale is when the page is
// restored from the browser's back/forward cache (bfcache) — so we reload only then.
class BackButtonCartRefresh {
  constructor() {
    this.init();
  }

  init() {
    // Only relevant on the cart page.
    if (!window.location.pathname.includes('/cart')) {
      return;
    }

    window.addEventListener('pageshow', (event) => {
      // event.persisted is true only when the page came from the bfcache, i.e. the
      // user navigated back/forward to a cached (potentially stale) cart page.
      if (event.persisted) {
        console.log('Cart page restored from bfcache - reloading to show current state');
        window.location.reload();
      }
    });
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BackButtonCartRefresh());
} else {
  new BackButtonCartRefresh();
}
